import React, { useEffect } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6New.css";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import arrow from "../../assets/images/arrow.png";
import weightLossStories from "../../assets/images/weight-loss-stories.png";
import { useNavigate } from "react-router-dom";

const IntakeFormPage5: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const completeIntakeStep2 = localStorage.getItem("complete-intake-step2");
    if (completeIntakeStep2) {
      navigate("/complete-intake/step-3", { replace: true });
    } else {
      navigate("/complete-intake/step-2", { replace: true });
    }
  }, []);
  const handleNext = () => {
    navigate("/complete-intake/step-4");
    localStorage.setItem("complete-intake-step3", "true");
  };

  const step = 3;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={30} step={step} />
        <div className="signup-content">
          <div className="signup-intro-text" style={{ textAlign: "center" }}>
            <span className="highlight-blue">1,500,000 users</span>{" "}
            <span className="highlight-black">
              say Claya is the #1 supplier of
            </span>{" "}
            <span className="highlight-blue">weight loss medication</span>{" "}
            <span className="highlight-black">online!</span>
          </div>
          <div className="intro-subtext" style={{ textAlign: "center" }}>
            <span className="subtext-font">
              Claya’s pharmacy network is the #1 rated supplier of weight loss
              medication online.
            </span>
          </div>
          <div className="weight-loss-story">
            <img
              src={weightLossStories}
              alt="Story 1"
              className="story-image"
            />
          </div>
          <button onClick={handleNext} className="next-btn sticky-btn">
            Continue{" "}
            <img src={arrow} alt="Arrow" style={{ marginLeft: "8px" }} />
          </button>
          <div className="suffix-content">
            <span className="content-typo">
              *Results may vary based on starting weight and program adherence.
              Medication prescriptions are at the discretion of medical
              providers and may not be suitable for everyone. Consult a
              healthcare professional before starting any weight loss program.
            </span>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage5;
